import React from 'react'
import ReactDOM from 'react-dom'
import Navigation from '../../../site/layout/Navigation'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('navigation')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-navigation').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <Navigation {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
